import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FilterDrawer from '../../../../atoms/filterDrawer/FilterDrawer';
import FilterItem from '../../../../atoms/filterItem/FilterItem';
import EDDepartmentMainFilter from '../../../../components/filters/EDDepartmentMainFilter';
import EDEducationLevelProgramFilter from '../../../../components/filters/EDEducationLevelProgramFilter';

const KnowledgeComponentsFilter = ({
  isDrawerOpen,
  onCloseDrawer,
  onSearch,
  currentFilters
}) => {
  const { t } = useTranslation();

  const [filters, setFilters] = useState(currentFilters);

  useEffect(() => {
    setFilters(currentFilters);
  }, [currentFilters]);

  const removeDuplicates = (array) => {
    return array.filter((item, index, self) =>
      typeof item === 'object'
        ? index === self.map((object) => object.id).indexOf(item.id)
        : index === self.map((value) => value).indexOf(item)
    );
  };

  const onChangeFilter = (filter) => {
    let filterValue = undefined;

    if (filter?.value?.length > 0) {
      filterValue = removeDuplicates(filter.value);
    }

    setFilters({
      ...filters,
      [filter.id]: filterValue
    });
  };

  return (
    <FilterDrawer
      title={t('Filter')}
      isDrawerOpen={isDrawerOpen}
      onCloseDrawer={onCloseDrawer}
      onReset={() => {
        onSearch({});
        setFilters({});
        onCloseDrawer();
      }}
      onSearch={() => onSearch(filters)}
      isSearchDisabled={Object.keys(filters).length === 0}
    >
      <FilterItem
        title={t('activity_education_level')}
        type='custom'
        defaultSelection={filters.educationYearGuid || []}
        customFilter={
          <EDEducationLevelProgramFilter
            multiple
            defaultValue={filters.educationYearGuid || []}
            onChange={(value) => {
              onChangeFilter({ id: 'educationYearGuid', value });
            }}
            isFilter={true}
          />
        }
      />

      <FilterItem
        title={t('learning_outcome_column_department')}
        type='custom'
        defaultSelection={filters.departments || []}
        customFilter={
          <EDDepartmentMainFilter
            multiple
            defaultValue={filters.departments || []}
            onChange={(value) => {
              onChangeFilter({ id: 'departments', value });
            }}
            isFilter={true}
          />
        }
      />
      <FilterItem
        title={t('kc_revision')}
        type='checkbox'
        multiple
        options={[
          {
            label: t('Kc_without_learning_outcomes'),
            value: 'KCWithoutLearningOutcome'
          },
          {
            label: t('Kc_without_dependencies'),
            value: 'KCWithoutDependencies'
          }
        ]}
        defaultSelection={filters.kc_revision || ''}
        onChange={(value) => {
          onChangeFilter({ id: 'kc_revision', value });
        }}
        isFilter={true}
      />
    </FilterDrawer>
  );
};

export default KnowledgeComponentsFilter;
